import React from "react";
import { Typography } from "@mui/material";
import { getHourFromTimestamp } from "../../../utils";

import StyledTextContent from "./styles";

const TextContent = ({ content, timestamp }) => {
  return (
    <StyledTextContent>
      <div className="left-section">
        <Typography
          variant="body2"
          color="black"
          fontFamily="sans-serif"
          sx={{ lineHeight: 1.2 }}
        >
          {`${content}`}
        </Typography>
      </div>
      <div className="right-section">
        {timestamp && (
          <Typography variant="caption" color="grey">{`${getHourFromTimestamp(
            timestamp
          )}`}</Typography>
        )}
      </div>
    </StyledTextContent>
  );
};

export default TextContent;
